import { Button, Dialog } from '@zoom/react-ui'
import { IconAlertCircleFill } from '@zoom/icons-react'
import { MappedFileTypes } from '../../constants'
import { useAppDispatch, useAppSelector } from '../../hooks/useRTK'
import { closeDialog, selectDialog, selectDialogProps } from '../../app/dialog'
import { selectFile } from '../../app/file'
import { useCreateFileGoogleMutation } from '../../app/appApiQueries'

const CollaborationInProgressDialog = () => {
  const dispatch = useAppDispatch()
  const { name, url, type } = useAppSelector(selectFile) || {}
  const dialogProps = useAppSelector(selectDialogProps)
  const dialog = useAppSelector(selectDialog)
  const [createFileGoogle] = useCreateFileGoogleMutation()

  let iconType = type
  let fileName = name
  let fileUrl: string | undefined = url

  if (dialog === 'collaborationInProgressNew') {
    iconType = dialogProps?.file || 'docx'
    fileName = 'New Document'
    fileUrl = dialogProps?.fileUrl
  }

  const handleClose = () => {
    dispatch(closeDialog())
  }

  const handleViewDocument = async () => {
    if (!fileUrl && fileName && iconType) {
      const data = await createFileGoogle({
        fileName,
        fileType: MappedFileTypes[iconType],
        share: false,
      }).unwrap()

      fileUrl = data.fileUrl
    }
    if (fileUrl)
      await zoomSdk.openUrl({ url: fileUrl }).then(() => handleClose())
  }

  return (
    <Dialog
      title={
        <div className='flex content-center text-lg'>
          <IconAlertCircleFill
            className='mr-2'
            size='24px'
            color='#FF2638'
          />
          Collaboration in progress
        </div>
      }
      sx={{
        '.ui-Dialog-title-root': {
          paddingBottom: '8px !important',
        },
        '.ui-Dialog-paper-root': {
          backgroundColor: '#FFF2F5 !important',
          margin: '20px !important',
        },
        '.MuiDialogActions-root': {
          paddingTop: '12px !important',
        },
      }}
      onEscapeKeyDown={handleClose}
      onCancel={handleClose}
      onBackdropClick={handleClose}
      closable
      footer={
        <div className='flex flex-shrink justify-between gap-2'>
          <Button
            size='large'
            className='flex-1'
            type='secondary'
            onClick={handleClose}
            sx={{
              background: 'white !important',
              '&:hover': {
                background: '#6E76801F !important',
              },
              '&:active': {
                background: '#6E76806B !important',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            className='!important min-w-[150px] flex-1'
            size='large'
            onClick={handleViewDocument}
          >
            View Document
          </Button>
        </div>
      }
    >
      <div className='pl-8'>You can&apos;t share another document.</div>
    </Dialog>
  )
}

export default CollaborationInProgressDialog
